module.exports = __webpack_public_path__ + "img/DashboardFeedback.570a9794.png";